import { render, staticRenderFns } from "./InfosetsTableSkeleton.vue?vue&type=template&id=1bb1412a&scoped=true&"
import script from "./InfosetsTableSkeleton.vue?vue&type=script&lang=ts&"
export * from "./InfosetsTableSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1412a",
  null
  
)

export default component.exports